import script from "./Table4WorkspaceAssets.vue?vue&type=script&setup=true&lang=js"
export * from "./Table4WorkspaceAssets.vue?vue&type=script&setup=true&lang=js"

import "./Table4WorkspaceAssets.vue?vue&type=style&index=0&id=44aa4b08&lang=scss&scoped=true"
import "./Table4WorkspaceAssets.vue?vue&type=style&index=1&id=44aa4b08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44aa4b08"]])

export default __exports__